import React from 'react';
import styled from 'styled-components';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actionsId?: string; // default target for portals, matches SortableTable default
}

const PageHeader = ({ title, subtitle, actionsId = 'page-title-actions' }: PageHeaderProps) => {
  return (
    <HeaderBar>
      <TitleGroup>
        <H1>{title}</H1>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </TitleGroup>
      <Actions id={actionsId} />
    </HeaderBar>
  );
};

export default PageHeader;

const HeaderBar = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 8px 0 16px;
`;

const TitleGroup = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const H1 = styled('h1')`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.25;
`;

const Subtitle = styled('div')`
  color: ${p => p.theme.colors?.subduedText || '#6b7280'};
  font-size: 14px;
`;

const Actions = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;